<!--
 * @Description: 会员管理
-->
<template>
  <div>
    <div class="TableTop">
      <!-- 搜索 -->
      <div class="TableSearch">
        <el-form :model="query" @submit.native.prevent>
          <el-form-item label="时间：" class="form-item-b0">
            <el-date-picker
              v-model="beginDate"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions"
              format="yyyy 年 MM 月 dd 日"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </el-form-item>
        </el-form>

        <div style="display: flex; line-height: 38px; margin-right: 16px">
          <div
            style="cursor: pointer; font-size: 14px"
            @click="changeDate(1, 0)"
            :style="{
              color: current === 0 ? 'blue' : '#000'
            }"
          >
            昨天
          </div>

          <div
            style="cursor: pointer; font-size: 14px; margin-left: 16px"
            @click="changeDate(0, 1)"
            :style="{
              color: current === 1 ? 'blue' : '#000'
            }"
          >
            今天
          </div>

          <div
            style="cursor: pointer; font-size: 14px; margin-left: 16px"
            @click="changeDate(7, 2)"
            :style="{
              color: current === 2 ? 'blue' : '#000'
            }"
          >
            一周
          </div>

          <div
            style="cursor: pointer; font-size: 14px; margin-left: 16px"
            @click="changeDate(30, 3)"
            :style="{
              color: current === 3 ? 'blue' : '#000'
            }"
          >
            一月
          </div>
        </div>

        <div class="TableSearch_btn">
          <el-button type="primary" size="small" @click="getList('place')">筛选</el-button>
          <el-button type="primary" size="small" @click="getList('place', 1)">去重</el-button>
          <el-button size="small" @click="init()">重置</el-button>
        </div>

        <div style="margin-left: 20px; font-size: 36px">
          {{ total }}
        </div>
      </div>
    </div>

    <!-- 表格 -->
    <el-table ref="TableListRef" class="TableList" border :data="list" v-loading="loading">
      <el-table-column label="序" align="center" type="index" min-width="50"></el-table-column>

      <el-table-column prop="IpAddress" label="IP" align="center"></el-table-column>

      <el-table-column prop="Type" label="类型" align="center"></el-table-column>

      <el-table-column prop="IpCount" label="访问次数" align="center">
        <template slot-scope="scope">
          {{ scope.row.IpCount || 1 }}
        </template>
      </el-table-column>

      <el-table-column prop="Date" label="访问时间" align="center">
        <template slot-scope="scope">
          {{ new Date(scope.row.Date) | parseTime('{y}-{m}-{d} {h}:{i}:{s}') }}
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <div class="fenye">
      <el-pagination
        class="TablePagination"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="query.pageindex"
        :page-sizes="[40, 60, 100]"
        :page-size="query.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: 'h5Jump',
  data() {
    return {
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }
        ]
      },

      list: [],
      total: 0,

      loading: true,

      beginDate: [
        this.$globalFun.parseTime(new Date(), '{y}-{m}-{d}'),
        this.$globalFun.parseTime(new Date(), '{y}-{m}-{d}')
      ],

      query: {
        pageindex: 1,
        pagesize: 40,
        search: '乡里仔H5跳转',
        type: '乡里仔H5跳转',
        beginTime: '',
        endTime: ''
      },

      current: 1
    }
  },

  created() {
    this.init()
  },

  computed: {},

  methods: {
    // 初始化
    init() {
      this.query.search = '乡里仔H5跳转'
      this.query.type = '乡里仔H5跳转'

      this.getList('place')
    },

    changeDate(num, current) {
      this.current = current
      const d = new Date()

      const start = this.$globalFun.parseTime(d.getTime() - 3600 * 1000 * 24 * num, '{y}-{m}-{d}')
      let end = this.$globalFun.parseTime(d, '{y}-{m}-{d}')

      if (num === 1) {
        end = start
      }
      console.log(start, end)

      this.beginDate = [start, end]

      this.getList('place')
    },

    // 获取列表
    async getList(place, isRepeat) {
      // 重置页数
      if (place) {
        this.query.pageindex = 1
        // 滚动条回到顶部
        this.$nextTick(() => {
          this.$refs.TableListRef.bodyWrapper.scrollTop = 0
        })
      }

      if (!this.beginDate || !this.beginDate.length) {
        this.query.beginTime = this.$globalFun.parseTime(new Date(), '{y}-{m}-{d}')
        this.query.endTime = this.$globalFun.parseTime(new Date(), '{y}-{m}-{d}')
      } else {
        this.query.beginTime = this.beginDate[0]
        this.query.endTime = this.beginDate[1]
      }
      console.log(this.query)

      const query = {
        ...this.query
      }

      if (isRepeat) {
        query.isRepeat = 1
      }

      const { data: res } = await this.$api.user.h5Jump(query)
      console.log('获取列表', res)

      if (isRepeat) {
        this.list = res.list.sort((a, b) => {
          return b.IpCount - a.IpCount
        })
      } else {
        this.list = res.list
      }

      this.total = res.count
      this.loading = false
    },

    // 每页显示条数和当前页码
    handleSizeChange(newSize) {
      this.query.pagesize = newSize
      this.getList()
      this.$nextTick(() => {
        this.$refs.TableListRef.bodyWrapper.scrollTop = 0
      })
    },
    handleCurrentChange(newPage) {
      this.query.pageindex = newPage
      this.getList()
      this.$nextTick(() => {
        this.$refs.TableListRef.bodyWrapper.scrollTop = 0
      })
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-table {
  font-size: 12px !important;
}
</style>
